import { CircularProgress, Grid } from '@material-ui/core';
import { useParams } from 'react-router';
import { loaderStyle } from 'src/utils/styles';
import EmployeeEditRequest from './EmployeeEditRequest';
import EmployeeViewRequest from './EmployeeViewRequest';
import RequestHeader from 'src/components/admin/Request/RequestHeader';
import { useQuery } from 'react-query';
import { getRequestById } from 'src/services/request.service';
import ErrorPage from './ErrorPage';

function EmployeeRequestPage({ preview = false, reqId }) {
  const { id } = useParams();
  // const empId = data?.employee?.id || data?.beneficiary?.employee?.id;
  const {
    isLoading: loading,
    data: request,
    isError
  } = useQuery(['request', reqId || id], async () => {
    return await getRequestById({ id: reqId || id });
  });

  if (loading) return <CircularProgress style={loaderStyle} />;
  if (isError) return <ErrorPage />;
  return (
    <>
      <Grid item container>
        <Grid container direction="column" spacing={0} style={{ padding: '12px' }}>
          <RequestHeader
            data={{ request: request?.data }}
            showBalance={false}
            showBills={request?.data?.status !== 'OPEN'}
            showHistory={!preview}
            approvedAmountEgp={request?.data?.deserved_amount_egp}
          />
        </Grid>
      </Grid>
      {request?.data?.status === 'OPEN' && !preview ? (
        <EmployeeEditRequest data={request?.data} />
      ) : (
        <EmployeeViewRequest data={request?.data} />
      )}
    </>
  );
}

export default EmployeeRequestPage;
